<template>
  <div>
    <!-- Cabeçalho -->
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h5 class="mb-0">Usuários</h5>
      <b-button
        v-if="hasPermission('adicionar_usuarios')"
        variant="primary"
        class="d-flex align-items-center"
        @click="irParaCadastro"
      >
        <i class="bi bi-plus-circle-fill mr-2" title="Novo Cadastro"></i>
      </b-button>
    </div>

    <!-- Filtros -->
    <div class="d-flex mb-3" style="gap: 10px;">
      <input
        v-model="filters.nome"
        placeholder="Filtrar por Nome"
        class="form-control mr-2"
        @input="filtrar"
      />
      <input
        v-model="filters.email"
        placeholder="Filtrar por E-mail"
        class="form-control mr-2"
        @input="filtrar"
      />
      <input
        v-model="filters.perfil"
        placeholder="Filtrar por Perfil"
        class="form-control mr-2"
        @input="filtrar"
      />
      <b-button
        variant="secondary"
        @click="limparFiltros"
        class="d-flex align-items-center justify-content-center"
      >
        <i class="bi bi-funnel mr-2" title="Limpar Filtro"></i>
      </b-button>
    </div>

    <!-- Tabela customizada -->
    <table class="table table-striped table-hover">
      <thead>
        <tr>
          <th>
            <button class="btn btn-link p-0" @click="changeSort('id')">
              # {{ arrow('id') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="changeSort('pessoa_fisica_nome')">
              Nome {{ arrow('pessoa_fisica_nome') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="changeSort('email')">
              E-mail {{ arrow('email') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="changeSort('perfil_nome')">
              Perfil {{ arrow('perfil_nome') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="changeSort('is_active')">
              Status {{ arrow('is_active') }}
            </button>
          </th>
          <th class="text-end">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="u in usuarios" :key="u.id">
          <td>{{ u.id }}</td>
          <td>{{ u.pessoa_fisica_nome }}</td>
          <td>{{ u.email }}</td>
          <td>{{ u.perfil_nome }}</td>
          <td>{{ u.is_active ? 'Ativo' : 'Inativo' }}</td>
          <td class="text-end">
            <i
              v-if="hasPermission('detalhar_usuarios')"
              class="bi bi-eye-fill text-primary mx-2"
              title="Detalhar"
              @click="detalhar(u.id)"
            ></i>
            <i
              v-if="hasPermission('alterar_usuarios')"
              class="bi bi-pencil-fill text-warning mx-2"
              title="Editar"
              @click="editar(u.id)"
            ></i>
            <i
              v-if="hasPermission('excluir_usuarios')"
              class="bi bi-trash-fill text-danger mx-2"
              title="Excluir"
              @click="excluir(u.id)"
            ></i>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Paginação -->
    <div class="d-flex justify-content-between align-items-center mt-3">
      <div>
        Mostrando {{ startRow }} a {{ endRow }} de {{ totalItems }} registros
      </div>
      <div class="d-flex align-items-center" style="gap: .5rem;">
        <b-form-select
          v-model="limit"
          :options="pageOptions.map(n => ({ value: n, text: n + ' / página' }))"
          size="sm"
          style="width: 6rem"
          @change="changeLimit"
        />
      </div>
      <div class="d-flex align-items-center">
        <b-pagination
          v-model="page"
          :per-page="limit"
          :total-rows="totalItems"
          size="sm"
          limit="5"
          @input="load"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue'
import { useRouter } from 'vue-router'
import axios from '@/services/axios'
import { BButton, BPagination, BFormSelect } from 'bootstrap-vue-next'
import { useSortableTable } from '@/utils/useSortableTable'
import { usePermissions } from '@/composables/usePermissions'

const router = useRouter()
const { fetchPermissions, hasPermission } = usePermissions()

// aqui vêm items, totalItems, page, limit, filters, load, sort e arrow
const {
  items: usuarios,
  totalItems,
  page,
  limit,
  filters,
  load,
  sort: changeSort,
  arrow
} = useSortableTable(
  `/configuracoes/usuarios`,
  { key: 'email', order: 'asc' }
)

const pageOptions = ref([10, 15, 20, 25, 50])
const startRow    = computed(() => (page.value - 1) * limit.value + 1)
const endRow      = computed(() => Math.min(page.value * limit.value, totalItems.value))

function filtrar() {
  page.value = 1
  load()
}

function limparFiltros() {
  filters.value.nome  = ''
  filters.value.email = ''
  filters.value.perfil = ''
  page.value    = 1
  load()
}

function changeLimit() {
  page.value = 1
  load()
}

function irParaCadastro() {
  router.push('/configuracoes/usuarios/novo')
}
function detalhar(id) {
  router.push(`/configuracoes/usuarios/${id}/detalhar`)
}
function editar(id) {
  router.push(`/configuracoes/usuarios/${id}`)
}
async function excluir(id) {
  if (confirm('Deseja excluir este usuário?')) {
    await axios.delete(`/configuracoes/usuarios/${id}`)
    load()
  }
}

watch(page, () => {
  load()
})

watch(limit, () => {
  page.value = 1
  load()
})



onMounted(async () => {
  await fetchPermissions()
  // inicializa filtros antes do primeiro load
  filters.nome  = ''
  filters.email = ''
  filters.perfil = ''
  load()
})
</script>

<style scoped>
:deep(.pagination.pagination-sm .page-link) {
  line-height: 1;
  font-size: 0.8rem !important;
  border-radius: 0 !important;
}
</style>
